<template>
  <div class="bottom flex flex0 bt">
    <div class="flex flex1 flex-center-2 flex-center" @click="checked">
      <font class="iconfont fs20 color_main" v-if="!picked">&#xe720;</font>
      <font class="iconfont fs20 color_main" v-if="picked">&#xe721;</font>
      <p class="fs14 ml5">
        我已阅读并同意 <br>
        <span class="fs12 color_main" @click.stop="yhxy">《浙二网络医学中心服务协议》</span>
      </p>
    </div>
    <v-common-btn class="next flex0" @click="next">下一步</v-common-btn>
    <!--    <div class="next bg_main color_fff flex0" @click="next">下一步</div>-->
  </div>
</template>

<script>
import {hasReadYhxyCache} from "../lib/cache";
import VCommonBtn from "./v-common-btn";

export default {
  name: "v-wxts-bottom",
  components: {VCommonBtn},
  props: {
    module: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      picked: false
    }
  },
  created() {
    this.getPicked();
  },
  watch: {
    $route() {
      this.getPicked();
    }
  },
  methods: {
    async checked() {
      this.picked = !this.picked;
    },
    async getPicked() {
      const cache = hasReadYhxyCache.get();
      this.picked = (cache && cache[this.module]) || false;
      /*const picked = await systemService.ysxyGet('CONSULT_INFO');
      return !picked || false;*/
    },
    yhxy() {

      this.$router.push({
        path: '/news/ysxy',
        query: {
          type: '',
          module: this.module,
          title: '用户协议'
        }
      })
    },
    next() {
      if (this.picked) this.$emit('next', '1');
      else bus.$emit('msg', '请先阅读用户协议');
    }
  },
}
</script>

<style scoped lang="scss">
@import "../common/public";

.bottom {
  height: px2rem(50px);

  p {
    line-height: 1.2;
  }

  .next {
    font-size: 16px;
    line-height: px2rem(50px);
    height: px2rem(50px);
    width: 40%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/v-wxts-bottom.vue